"use strict";

exports.__esModule = true;
exports.SlotData = exports.BlendMode = void 0;

var _Utils = require("./Utils");

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/

/** Stores the setup pose for a {@link Slot}. */
var SlotData = function SlotData(index, name, boneData) {
  /** The index of the slot in {@link Skeleton#getSlots()}. */
  this.index = 0;
  /** The name of the slot, which is unique across all slots in the skeleton. */

  this.name = null;
  /** The bone this slot belongs to. */

  this.boneData = null;
  /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
   * color tinting. */

  this.color = new _Utils.Color(1, 1, 1, 1);
  /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
   * color's alpha is not used. */

  this.darkColor = null;
  /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */

  this.attachmentName = null;
  /** The blend mode for drawing the slot's attachment. */

  this.blendMode = null;
  if (index < 0) throw new Error("index must be >= 0.");
  if (!name) throw new Error("name cannot be null.");
  if (!boneData) throw new Error("boneData cannot be null.");
  this.index = index;
  this.name = name;
  this.boneData = boneData;
};
/** Determines how images are blended with existing pixels when drawn. */


exports.SlotData = SlotData;
var BlendMode;
exports.BlendMode = BlendMode;

(function (BlendMode) {
  BlendMode[BlendMode["Normal"] = 0] = "Normal";
  BlendMode[BlendMode["Additive"] = 1] = "Additive";
  BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
  BlendMode[BlendMode["Screen"] = 3] = "Screen";
})(BlendMode || (exports.BlendMode = BlendMode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE4QkE7O0FBOUJBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQWdDQTtJQUNhQSxRLEdBd0JaLGtCQUFhQyxLQUFiLEVBQTRCQyxJQUE1QixFQUEwQ0MsUUFBMUMsRUFBNEQ7RUF2QjVEO0VBQ0EsYUFBZ0IsQ0FBaEI7RUFFQTs7RUFDQSxZQUFlLElBQWY7RUFFQTs7RUFDQSxnQkFBcUIsSUFBckI7RUFFQTs7O0VBRUEsYUFBUSxJQUFJQyxZQUFKLENBQVUsQ0FBVixFQUFhLENBQWIsRUFBZ0IsQ0FBaEIsRUFBbUIsQ0FBbkIsQ0FBUjtFQUVBOzs7RUFFQSxpQkFBbUIsSUFBbkI7RUFFQTs7RUFDQSxzQkFBeUIsSUFBekI7RUFFQTs7RUFDQSxpQkFBdUIsSUFBdkI7RUFHQyxJQUFJSCxLQUFLLEdBQUcsQ0FBWixFQUFlLE1BQU0sSUFBSUksS0FBSixDQUFVLHFCQUFWLENBQU47RUFDZixJQUFJLENBQUNILElBQUwsRUFBVyxNQUFNLElBQUlHLEtBQUosQ0FBVSxzQkFBVixDQUFOO0VBQ1gsSUFBSSxDQUFDRixRQUFMLEVBQWUsTUFBTSxJQUFJRSxLQUFKLENBQVUsMEJBQVYsQ0FBTjtFQUNmLEtBQUtKLEtBQUwsR0FBYUEsS0FBYjtFQUNBLEtBQUtDLElBQUwsR0FBWUEsSUFBWjtFQUNBLEtBQUtDLFFBQUwsR0FBZ0JBLFFBQWhCO0FBQ0EsQztBQUdGOzs7O0FBQ0EsSUFBWUcsU0FBWjs7O0FBQUEsV0FBWUEsU0FBWixFQUFxQjtFQUFHQTtFQUFRQTtFQUFVQTtFQUFVQTtBQUFRLENBQTVELEVBQVlBLFNBQVMseUJBQVRBLFNBQVMsTUFBckIiLCJuYW1lcyI6WyJTbG90RGF0YSIsImluZGV4IiwibmFtZSIsImJvbmVEYXRhIiwiQ29sb3IiLCJFcnJvciIsIkJsZW5kTW9kZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvU2xvdERhdGEudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=